import { useEffect, useState } from 'react';
import { FriendRequestNotification } from './FriendRequestNotification';
import { getNotificationsByUserIdServer } from '@/lib/db/queries/notifications';
import type { Notification } from '@/lib/db/queries/notifications';
import { apiFetch } from '@/lib/api-fetch';

interface NotificationListProps {
  userId: string;
}

export function NotificationList({ userId }: NotificationListProps) {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNotifications();
  }, [userId]);

  const loadNotifications = async () => {
    setLoading(true);
    try {
      const response = await apiFetch(`/api/notifications?userId=${userId}&limit=50`);
      if (response.ok) {
        const data = await response.json();
        setNotifications(data.notifications || []);
      }
    } catch (error) {
      console.error('Failed to load notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-4 text-center text-arc-text-muted text-sm">Loading notifications...</div>;
  }

  if (notifications.length === 0) {
    return <div className="p-4 text-center text-arc-text-muted text-sm">No notifications</div>;
  }

  return (
    <div className="divide-y divide-arc-border">
      {notifications.map((notification) => {
        if (notification.type === 'friend_request') {
          return (
            <FriendRequestNotification
              key={notification.id}
              notification={notification}
              onUpdate={loadNotifications}
            />
          );
        }
        
        // Generic notification for other types
        return (
          <div
            key={notification.id}
            className={`p-4 hover:bg-arc-panel-soft transition-colors ${
              !notification.read ? 'bg-arc-panel-soft' : ''
            }`}
          >
            <div className="font-semibold text-arc-text-main text-sm">{notification.title}</div>
            {notification.body && (
              <div className="text-xs text-arc-text-muted mt-1">{notification.body}</div>
            )}
            <div className="text-xs text-arc-text-muted mt-2">
              {new Date(notification.createdAt).toLocaleString()}
            </div>
          </div>
        );
      })}
    </div>
  );
}

